import { newrelic } from "@jti/fe-clients";
export const handleError = (message) => {
    console.error(message);
    newrelic.noticeError(new Error(message));
};
//# sourceMappingURL=handleError.js.map